import React from 'react';
import PropTypes from 'prop-types';
import Shop from '~/modules/ecommerceShops/containers/shopCard/Shop';
import ProductsSlider from '~/modules/ecommerceCoreUI/components/listViewLayout/ProductsSlider';

const PinnedShops = ({ shopsList }) => (
  <React.Fragment>
    {shopsList.length > 0 && (
      <ProductsSlider isVertical>
        {shopsList.map(entry => (
          // eslint-disable-next-line no-underscore-dangle
          <Shop isAd shopInfo={entry} key={entry.id} />
        ))}
      </ProductsSlider>
    )}
  </React.Fragment>
);

PinnedShops.propTypes = {
  shopsList: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default PinnedShops;
